module.exports = __webpack_public_path__ + "github-white.svg?ba63e648d847935035aabf6f633a088e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-media/github-white.svg
// module id = 38
// module chunks = 0